import React from 'react';

const LoadingSpinner = ({ message = 'Cargando configuración...' }) => {
  return (
    <div className="text-center py-5">
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Cargando...</span>
      </div>
      <div className="mt-2">{message}</div>
    </div>
  );
};

export default LoadingSpinner;
